import { GridColumns } from '@mui/x-data-grid-pro'
import { ProductOrderReceiptDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { getProductOrderReceipts, setProductOrderReceiptFilters } from '@state/reducers/productOrderReceiptReducer'
import { AppDispatch } from '@state/store'
import BaseConfigTable from './BaseConfigTable'
import { IconButton } from '@mui/material'
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch'
import moment from 'moment'

interface Props {
  orderId?: string
}

export default function ProductOrderReceiptsTable({ orderId }: Props) {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setProductOrderReceiptFilters({}))
    }
  }, [])
  
  const columns: GridColumns<ProductOrderReceiptDto> = useMemo(
    () => [
      { field: 'receivedAt', headerName: 'Réceptionné le', width: 135, valueGetter: (params) => 
        moment(params.row.receivedAt).format('DD/MM/YYYY HH:mm'), },
      { field: 'receivedByMember', headerName: 'Par', width: 140, valueGetter: (params) => 
        `${params.row.receivedByMember.firstName} ${params.row.receivedByMember.lastName}` },
      { field: 'content', headerName: 'Contenu', width: 270, valueGetter: (params) => 
        params.row.stockTransactions.map((st) => `Lot ${st.productBatch.lotNumber} (${st.unitsDelta} x ${st.productBatch.productCatalog.name}) dans ${st.storageLocation.name}`).join(', ') },
      { field: 'deliveryNote', headerName: 'Bon livraison', width: 110, renderCell: (params) => params.row.deliveryNote?.url && 
        <IconButton onClick={() => params.row.deliveryNote && window.open(params.row.deliveryNote.url, '_blank')}>
          <ContentPasteSearchIcon />
        </IconButton> 
      },
      { field: 'releaseCertificate', headerName: 'Document libération', width: 120, renderCell: (params) => params.row.releaseCertificate?.url && 
        <IconButton onClick={() => params.row.releaseCertificate && window.open(params.row.releaseCertificate.url, '_blank')}>
          <ContentPasteSearchIcon />
        </IconButton> 
      },
      { field: 'courierFullName', headerName: 'Nom livreur', width: 110 },
      { field: 'externalSupplierName', headerName: 'Nom fournisseur externe', width: 160 },
      { field: 'externalSupplierAddress', headerName: 'Adresse fournisseur externe', width: 185 },
      { field: 'comment', headerName: 'Commentaire', width: 250 },
      { field: 'errorComment', headerName: 'Commentaire erreur', width: 250 },
      { field: 'createdAt', headerName: 'Enregistré le', width: 145, valueGetter: (params) => moment(params.row.createdAt).format('DD/MM/YYYY HH:mm'), },
      { field: 'createdBy', headerName: 'Par', width: 140, valueGetter: (params) => `${params.row.createdBy?.firstName || ''} ${params.row.createdBy?.lastName || ''}` },
    ],
    [],
  )

  return (
    <BaseConfigTable<ProductOrderReceiptDto>
      columns={columns}
      selectRows={(state) => state.productOrderReceipt.crud.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setProductOrderReceiptFilters({ orderId }))
        return dispatch(getProductOrderReceipts())
      }}
      withActions={false}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setProductOrderReceiptFilters({ page }))
        dispatch(getProductOrderReceipts())
      }}
      removeToolbar
    />
  )
}
